// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-col {
  text-align: center;
}

.footer-buttons {
  display: flex;
  justify-content: center;
  gap: 25%;
  max-width: 600px;
  margin: 0 auto;
}

ion-toolbar {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 20px;
  --padding-end: 20px;
}

ion-grid {
  --ion-grid-padding: 0;
}

ion-col {
  --ion-grid-column-padding: 0;
}

.ion-badge-footer-version {
  position: absolute;
  right: 5px;
  top: 17px;
}

@media (max-width: 450px) {
  .footer-buttons {
    gap: 15%;
  }
  .ion-badge-footer-version {
    font-size: 0.75rem;
    top: 18px;
  }
}
@media (max-width: 300px) {
  .footer-buttons {
    gap: 5%;
  }
  .ion-badge-footer-version {
    font-size: 0.65rem;
    right: 2px;
    top: 19px;
  }
}
@media (max-width: 220px) {
  .footer-buttons {
    gap: 0%;
  }
  .ion-badge-footer-version {
    font-size: 0.5rem;
    right: 1px;
    top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AACF;;AAGA;EACE;IACE,QAAA;EAAF;EAGA;IACE,kBAAA;IACA,SAAA;EADF;AACF;AAIA;EACE;IACE,OAAA;EAFF;EAKA;IACE,kBAAA;IACA,UAAA;IACA,SAAA;EAHF;AACF;AAMA;EACE;IACE,OAAA;EAJF;EAOA;IACE,iBAAA;IACA,UAAA;IACA,SAAA;EALF;AACF","sourcesContent":["ion-col {\r\n  text-align: center;\r\n}\r\n\r\n.footer-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 25%;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n\r\nion-toolbar {\r\n  --padding-top: 0;\r\n  --padding-bottom: 0;\r\n  --padding-start: 20px;\r\n  --padding-end: 20px;\r\n}\r\n\r\nion-grid {\r\n  --ion-grid-padding: 0;\r\n}\r\n\r\nion-col {\r\n  --ion-grid-column-padding: 0;\r\n}\r\n\r\n.ion-badge-footer-version {\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 17px;\r\n}\r\n\r\n// Media queries for smaller screens\r\n@media (max-width: 450px) {\r\n  .footer-buttons {\r\n    gap: 15%;\r\n  }\r\n\r\n  .ion-badge-footer-version {\r\n    font-size: 0.75rem;\r\n    top: 18px;\r\n  }\r\n}\r\n\r\n@media (max-width: 300px) {\r\n  .footer-buttons {\r\n    gap: 5%;\r\n  }\r\n\r\n  .ion-badge-footer-version {\r\n    font-size: 0.65rem;\r\n    right: 2px;\r\n    top: 19px;\r\n  }\r\n}\r\n\r\n@media (max-width: 220px) {\r\n  .footer-buttons {\r\n    gap: 0%;\r\n  }\r\n\r\n  .ion-badge-footer-version {\r\n    font-size: 0.5rem;\r\n    right: 1px;\r\n    top: 20px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
